import styled from 'styled-components';
import { ImageButtonTemplate } from './ImageButtonTemplate';
import { IImageButtonProps } from './ImageButton';
import { rem } from 'polished';

export const ImageButtonStyled = styled(ImageButtonTemplate)<IImageButtonProps>`
    position: relative;
    height: 100%;
    .img-btn-container {
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        position: absolute;
        height: 100%;
        width: 100%;

        &:not([tabindex='-1']) {
            &:focus-visible {
                opacity: 0.6;
            }
        }

        .pxAttention {
            margin-left: ${rem('12px')};
            display: flex;
            align-items: center;
            justify-content: center;
            flex: none;
            width: ${rem('24px')};
            height: ${rem('24px')};
            border-radius: 50%;
            background-color: ${({ theme }) => theme.colors.lozenge};

            svg {
                height: ${rem('15px')};
            }
        }

        .pxAttentionLabel {
            position: absolute;
            right: ${rem('8px')};
            bottom: ${rem('30px')};
            display: flex;
            align-items: center;
            justify-content: center;
            flex: none;
            height: ${rem('24px')};
            margin: auto ${rem('6px')} ${rem('6px')} auto;
            font-size: ${rem('12px')};
            padding: ${rem('6px')} ${rem('12px')};
            background-color: ${({ theme }) => theme.colors.lozenge};
        }

        .description {
            :after {
                visibility: hidden;
            }
        }

        &.active:hover {
            box-shadow: 0 0.2rem 0.5rem rgba(0, 0, 0, 0.2);
            cursor: pointer;
        }

        .top {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: ${rem('15px')} ${rem('15px')} 0;
            position: relative;
            z-index: 1;

            h1 {
                max-width: fit-content;
                text-transform: uppercase;
                line-height: 2rem;
                color: ${({ theme }) => theme.colors.black};
            }

            .sum {
                height: ${rem('24px')};
                width: ${rem('24px')};
                line-height: ${rem('18px')};
                font-size: ${rem('14px')};
                border-radius: ${rem('15px')};
                display: flex;
                align-items: center;
                justify-content: center;
                color: ${({ theme }) => theme.colors.white};
                margin: 0;
                margin-left: ${rem('16px')};
            }
        }

        .description {
            margin-block-start: 0;
            margin-block-end: 0;
            font-size: ${({ theme }) => theme.fontSizes.textSubMedium};

            span {
                font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
                color: ${({ theme }) => theme.colors.red3};
                position: relative;
                left: ${rem('4px')};
                top: ${rem('4px')};
            }

            :after {
                content: '';
                display: inline-block;
                vertical-align: middle;
                border-right: 0.15rem solid ${({ theme }) => theme.colors.white};
                border-bottom: 0.15rem solid ${({ theme }) => theme.colors.white};
                width: 0.7rem;
                height: 0.7rem;
                transform: rotate(-45deg);
                margin: 0.7rem;
            }
        }

        h1 {
            font-size: ${({ theme }) => theme.fontSizes.h5};
            width: ${rem('380px')};
        }

        img {
            display: block;
            max-height: ${rem('140px')};
            padding: 0;
            position: absolute;
            width: 100%;
            bottom: 0;
        }
    }
`;
